import React from "react";
import {Route, Routes} from "react-router-dom";
import {CircleTestPage} from "@/pages/circle-test";

export const CircleTestRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<CircleTestPage />} />
        </Routes>
    );
};
